import axios from "axios";
export class Configuration {
  //   appId;

  constructor() {}

  async getConfigurationByShop(shop) {
    const res = await axios
      .post("/configuration/getByShop", { shop: shop })
      .then((resp) => {
        return resp.data;
      })
      .catch((err) => {
        return err;
      });
    return res;
  }

  async updateMerchantData(
    shop,
    config,
    session,
    merchantKey,
    merchantPassword
  ) {
    const res = await axios
      .patch("/configuration/updateMerchantData", {
        shop: shop,
        config: config,
        session: session,
        merchantKey: merchantKey,
        merchantPassword: merchantPassword,
      })
      .then((resp) => {
        return resp.data;
      })
      .catch((err) => {
        return err;
      });
    return res;
  }
}
